export default __webpack_public_path__ + "static/media/dojang1.b37f3b67.jpg";